import { Component } from '@angular/core'
import { ColumnControlBaseComponent } from '../base/column-control-base.component'

@Component({
    selector: 'app-column-title',
    templateUrl: './column-title.component.html',
    styleUrls: ['./column-title.component.scss'],
    standalone: false
})
export class ColumnTitleComponent extends ColumnControlBaseComponent {}
